"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotionTheming = require("emotion-theming");

var _Card = require("./Card.style");

var _CardArticle = require("./CardArticle.style");

var _Typography = require("../../Typography");

var _Card2 = _interopRequireDefault(require("./Card"));

var _MarkdownRenderer = _interopRequireDefault(require("../../MarkdownRenderer"));

var _CardBadge = _interopRequireDefault(require("./CardBadge"));

var CardArticle = function CardArticle(_ref) {
  var badge = _ref.badge,
      banner = _ref.banner,
      copy = _ref.copy,
      image = _ref.image,
      label = _ref.label,
      link = _ref.link,
      tag = _ref.tag,
      title = _ref.title,
      tags = _ref.tags,
      tagsLabel = _ref.tagsLabel;

  var _ref2 = (0, _emotionTheming.useTheme)(),
      cards = _ref2.cards;

  var hasTags = tags && tags.length > 0; // Limit tags length to maximum of 3.

  var renderTags = hasTags && tags.length > 3 ? tags.slice(0, 3) : tags;
  return /*#__PURE__*/_react.default.createElement(_Card2.default, {
    url: link === null || link === void 0 ? void 0 : link.url
  }, /*#__PURE__*/_react.default.createElement(_Card.Wrapper, {
    image: image
  }, banner && /*#__PURE__*/_react.default.createElement(_Card.CardBanner, banner), image && /*#__PURE__*/_react.default.createElement(_Card.Overlay, null, /*#__PURE__*/_react.default.createElement(_Card.CardImage, Object.assign({
    preserveStackingContext: true,
    mediaType: "backgroundImage"
  }, image), badge && /*#__PURE__*/_react.default.createElement(_CardBadge.default, {
    label: badge,
    variant: "article"
  }))), /*#__PURE__*/_react.default.createElement(_Card.CardContent, {
    image: image
  }, /*#__PURE__*/_react.default.createElement(_CardArticle.CardArticleContentInner, {
    height: hasTags ? '19.3rem' : '17.2rem'
  }, tag && /*#__PURE__*/_react.default.createElement(_CardArticle.CardArticleTag, {
    size: "xsmall"
  }, tag), title && /*#__PURE__*/_react.default.createElement(_Card.CardTitle, {
    size: cards.titleTextSize
  }, title), /*#__PURE__*/_react.default.createElement(_CardArticle.CardArticleCopy, null, /*#__PURE__*/_react.default.createElement(_MarkdownRenderer.default, {
    html: copy,
    copySize: cards.copyTextSize
  })), label && /*#__PURE__*/_react.default.createElement(_CardArticle.CardArticleLabel, null, /*#__PURE__*/_react.default.createElement(_Typography.Body, {
    size: cards.labelTextSize
  }, label)), hasTags && renderTags && /*#__PURE__*/_react.default.createElement(_CardArticle.TagsWrapper, null, /*#__PURE__*/_react.default.createElement(_CardArticle.TagsLabel, null, tagsLabel), renderTags.join(', '))))));
};

CardArticle.propTypes = {
  /** Card badge text - placed on the image */
  badge: _propTypes.default.string,

  /** Card copy - placed under the title */
  copy: _propTypes.default.string,
  image: _propTypes.default.shape({
    src: _propTypes.default.string,
    fluid: _propTypes.default.shape({}),
    fixed: _propTypes.default.shape({})
  }),

  /** Card image label */
  label: _propTypes.default.string,

  /** Card tag, appears above title, mainly used to describe content type */
  tag: _propTypes.default.string,

  /** Card title */
  title: _propTypes.default.string,

  /** Card Primary CTA - links to main title and image */
  link: _propTypes.default.shape({
    /** card link URL */
    url: _propTypes.default.string
  }),
  banner: _propTypes.default.shape({
    image: _propTypes.default.shape({
      src: _propTypes.default.string,
      fluid: _propTypes.default.shape({}),
      fixed: _propTypes.default.shape({})
    }),
    label: _propTypes.default.string
  }),
  tags: _propTypes.default.arrayOf(_propTypes.default.string),
  tagsLabel: _propTypes.default.string
};
CardArticle.defaultProps = {
  badge: '',
  copy: '',
  label: '',
  tag: '',
  title: '',
  link: null,
  image: null,
  banner: null,
  tags: null,
  tagsLabel: 'Tags:'
};
var _default = CardArticle;
exports.default = _default;